import { Component, NgZone, OnInit, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { AdvtService } from '../../_services/advt.service';
import { AlertService } from '../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';

@Component({
  selector: 'app-receive-request',
  templateUrl: './receive-request.component.html',
  styleUrls: ['./receive-request.component.css']
})
export class ReceiveRequestComponent implements OnInit {
  @ViewChild('alertViewBidTemplate') alertViewBidTemplate: TemplateRef<any>;

  public seller_id;
  pageSize = 10;
  pageNo = 1;
  loading: Boolean = true;
  mainLoader;
  recieveBidLength;
  recieveBidList;
  user_id;
  ID;
  allCategories;
  categoryId = 0;
  item_id: string;
  itemId: string;
  buyer_id: string;
  amount: string;
  address: string;
  lng: string;
  lat: string;
  bidRequestId: string;
  modalRef: BsModalRef;
  bidStatus: string;
  titleViewBidModal: string;
  bidAmountList: string;
  warSameBid: boolean = false;

  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout: 5000
  }

  constructor(private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private http: Http) { }

  ngOnInit() {

    this.mainLoader = '../../assets/images/BigLoader.gif';


    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.user_id = userInfo.result.id;
    }

    this.advtService.getAllCategories().subscribe((data) => {
      this.allCategories = data;
    });

    this.bidList(this.user_id);

  }

  public _ReceivedRequestHistory() {
    this.loading = true;
    var limit = this.pageSize;
    var offset = 0;

    this.advtService.getBid(this.user_id, limit, offset, 'received', this.categoryId)
      .subscribe(data => {
        this.recieveBidList = data.received;
        this.recieveBidLength = data.receivedcount;
        this.loading = false;
      }, error => {
        this.alertService.error(error);

      });
  }

  /**
* Function to get List
* @param seller_id 
* @param category_id 
*/
  public bidList(user_id) {
    this.loading = true;
    var limit = this.pageSize;
    var offset = 0;

    this.advtService.getBid(user_id, limit, offset, 'received')
      .subscribe(data => {
        this.recieveBidList = data.received;
        // Other processing logic
        this.recieveBidLength = data.receivedcount;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
      });
  }


  /**
  * This function is used for pagination
  * @param data
  */
  pagingAgent(data) {
    this.loading = true;
    this.pageNo = (data * this.pageSize) - this.pageSize;
    var limit = this.pageSize;
    var offset = this.pageNo;
    var user_id = this.user_id;

    this.advtService.getBid(user_id, limit, offset, 'received')
      .subscribe(response => {
        this.recieveBidList = response.received;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
        this.loading = false;
      });
  }

  bitAccept(recieveBid: any) {
    this.bidStatus = recieveBid.bid_status_id;
    this.item_id = recieveBid.item_id;
    this.bidRequestId = recieveBid.bid_request_id;

    let input = {
      item_id: `${this.item_id}`,
      buyer_id: `${recieveBid.buyer_id}`,
      amount: `${recieveBid.amount}`,
      address: `${recieveBid.address}`,
      lng: `${recieveBid.lng}`,
      lat: `${recieveBid.lat}`,
      type: 2,
    };

    this.advtService.sendBit(this.item_id, this.bidRequestId, '2', input)
      .subscribe(data => {
        if (data.status === 403) {
          this.warSameBid = true;
          this.alertService.warning(data.message);
        }
        else {
          recieveBid.bid_status_id = 2; // Update bid_status_id to 2 after accepting
        }
      });
  }

  bitReject(recieveBid: any) {
    this.itemId = recieveBid.item_id;
    this.bidRequestId = recieveBid.bid_request_id;
    let input = {
      item_id: this.itemId,
      buyer_id: `${recieveBid.buyer_id}`,
      amount: `${recieveBid.amount}`,
      address: `${recieveBid.address}`,
      lng: `${recieveBid.lng}`,
      lat: `${recieveBid.lat}`,
      type: 2,
    };

    this.advtService.sendBit(this.itemId, this.bidRequestId, '3', input)
      .subscribe(data => {
        if (data.status === 403) {
          this.warSameBid = true;
          this.alertService.warning(data.message);
        }
        else {
          recieveBid.bid_status_id = 3; // Update bid_status_id to 3 after rejecting
        }
      });
  }


  openViewBidModal() {
    this.modalRef = this.modalService.show(this.alertViewBidTemplate);
  }

  viewBid(recieveBid) {
    this.titleViewBidModal = recieveBid.title;
    this.bidAmountList = recieveBid.bid_amountnew;
    this.recieveBidList.forEach(bid => {
    });
    this.openViewBidModal();
  }

  CancelButton() {
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-data/receive-request/receive-request.component.ts